'use strict'

import React from 'react';
import uuid from 'uuid';
import request from 'superagent';

import Field from '../components/Field3.jsx';

export default class TrainingConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.state={details:false,users:this.props.access};
  }

  toggle(event) {
    event.preventDefault();
    this.setState({details:!this.state.details});
  }

  addUsers(event) {
    event.preventDefault();
    let users=event.target.elements.users.value.split("\n");
    users.forEach(user=>{
      request
        .post("/")
        .send({type:"addPerson", tenant: {id: this.props.tenant.id}, person:{id: uuid.v4(), email:user}})
        .then(response=>{
          console.log("Added person");
          this.setState({users: this.state.users.concat({email:user.email})});
        })
        .catch(error=>{
          console.log("[ERROR] Not able to add person "+user.email+", got",error);
          alert("An error occured");
        })

    })
    console.log("Add users: "+JSON.stringify(users));
  }

  render() {
    return this.state.details ? (
      this.props.tenant.sso!==undefined ? (
        <div style={{paddingTop:10, paddingBottom:20}}>
          <div>
            <b>Training domain is configured</b>
          </div>
          <div style={{paddingLeft: 20}}>
            Domain:<i><a href={"https://"+this.props.tenant.sso.domain+"/"}>{this.props.tenant.sso.domain}</a></i>
          </div>
          <div style={{display:"none", paddingTop:10, maxWidth:800}}>
            <form onSubmit={this.addUsers.bind(this)}>
              <Field name="users" title="New users" description="Enter email address to new users, one line per user" height="3"/>
              <input className="save" type="submit" value="Add users"/>
            </form>
          </div>
          {this.state.users!==undefined ? (
            <div style={{paddingTop:10}}>
              <b>Access granted to:</b>
              <ul style={{paddingLeft:10}}>
                {this.state.users.map(item=><li key={item.email}>{item.email}</li>)}
              </ul>
            </div>
          ) : (
            <div>
              <i>No users are granted access (yet)</i>
            </div>
          )}
        </div>
      ) : (
        <div>
          {JSON.stringify(this.props.tenant)}
          <h3>Training domain</h3>
          <form action="/training/domain" method="POST">
            <input type="hidden" name="tenant" value={this.props.tenant.id}/>
            <div style={{paddingBottom: 10}}>
              <b>Domain</b><br/>
              <input size="30" name="domain" placeholder="yourdomain" autoComplete="off" style={{textAlign:"right"}}/>.progreto.com<br/>
              <i>Domain is the address users in your organization shall use to access your training account.</i>
            </div>
            <input type="button" onClick={this.toggle.bind(this)} value="Cancel"/> <input type="submit" value="Configure Domain"/>
          </form>
        </div>
      )
    ) : (
      <div style={{paddingTop:10}}>
        <a href="#" onClick={this.toggle.bind(this)}>Configure Training Domain</a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./views/training/TrainingConfiguration.jsx